import React, { useRef, useState } from "react";
import sendMessageIcon from "@src/assets/auctionAgent/sendMessageIcon.svg";
import styled from "styled-components";
import { useActivateChattingRoom, useSendMessage } from "@src/hooks/auctionAgent/chat";
import { useSendBirdChat } from "@src/contexts/SendBirdChatContext";

interface ChattingInputProps {
    chattingRoomNo: number;
}

const ChattingInput = ({ chattingRoomNo }: ChattingInputProps) => {
    const { mutate: sendMessage } = useSendMessage();
    const { msgMessages, sendBirdMessages } = useSendBirdChat();
    const inputRef = useRef<HTMLInputElement>(null);
    const { mutate: activateChattingRoom } = useActivateChattingRoom();

    const handleSendMessage = () => {
        const message = inputRef.current?.value;
        if (!message) return;
        sendMessage(
            {
                message: message,
                chattingRoomNo: chattingRoomNo,
            },
            {
                onSuccess: () => {
                    if (msgMessages.length === 0 && sendBirdMessages.length === 0) {
                        // 채팅방 활성화
                        activateChattingRoom(chattingRoomNo);
                    }
                },
            },
        );

        inputRef.current.value = "";
    };
    const handleKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            handleSendMessage();
        }
    };
    return (
        <ChattingInputBox>
            <ChattingInputStyle type="text" placeholder="메시지를 입력해주세요" onKeyUp={handleKeyUp} ref={inputRef} />
            <button className="send-message-button" onClick={handleSendMessage}>
                <img src={sendMessageIcon} alt="sendMessageIcon" />
            </button>
        </ChattingInputBox>
    );
};

export default ChattingInput;

const ChattingInputBox = styled.div`
    width: 100%;
    height: 88px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;

    img {
        width: 28px;
        height: 28px;
    }
`;

const ChattingInputStyle = styled.input`
    width: 100%;
    border-radius: 100px;
    padding: 14px;
    background-color: #f2f3f6;
    border: none;

    &::placeholder {
        font-size: 14px;
        font-weight: 400;
        color: #b1aeb8;
    }
`;
